(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ImgProcess"] = factory();
	else
		root["ImgProcess"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["parse"] = parse;
/* harmony export (immutable) */ __webpack_exports__["stringify"] = stringify;
/* harmony export (immutable) */ __webpack_exports__["isCDNUrl"] = isCDNUrl;
/* harmony export (immutable) */ __webpack_exports__["append"] = append;
/* harmony export (immutable) */ __webpack_exports__["clean"] = clean;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zzc_webp_check__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zzc_webp_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zzc_webp_check__);


function isType(s, typeString) {
    return {}.toString.call(s) === '[object ' + typeString + ']';
}
function isObject(s) {
    return isType(s, 'Object');
}
function isArray(s) {
    return Array.isArray ? Array.isArray(s) : isType(s, 'Array');
}
function hasOwnProperty(obj, name) {
    return obj.hasOwnProperty(name);
}
function toString(s) {
    return s + '';
}

var IS_BROWSER_ENV = typeof window !== 'undefined';
var START_PARAM = '!/';
var RE_EXT_QUERY = /(\.[a-z])?(!\/.+)/i;
var RE_TRIM_SLASH = /^\/+|\/+$/g;

/**
 * 解析字符串, 构造出对象
 *
 * @param str
 * @returns {{}}
 */
function parse() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var object = {};

    if (str) {
        // 从完整url中提取
        var match = str.match(RE_EXT_QUERY);
        if (isArray(match) && match[0]) {
            str = match[0].replace(START_PARAM, '');
        }

        str = str.replace(RE_TRIM_SLASH, '');

        if (str) {
            var splitArr = str.split('/');

            var name = void 0;
            while (name = splitArr.shift()) {
                if (!hasOwnProperty(object, name)) {
                    object[name] = toString(splitArr.shift());
                }
            }
        }
    }

    return object;
}

/**
 * 将对象转换为字符串
 *
 * @param object
 * @returns {string}
 */
function stringify() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (isObject(object)) {
        var result = [];
        for (var key in object) {
            if (hasOwnProperty(object, key)) {
                result.push(key + '/' + object[key]);
            }
        }

        if (result.length) {
            return START_PARAM + result.join('/');
        }
    }

    return '';
}

var RE_CDN_DOMAIN = /imgcdn(\d+)\.zuzuche\.com/;
var RE_CDN_DOMAIN_UPAIYUN = 'upaiyun.com';
function isCDNUrl(url) {
    return url && (RE_CDN_DOMAIN.test(url) || url.indexOf(RE_CDN_DOMAIN_UPAIYUN) > -1);
}

/**
 * 追加参数
 *
 * @param url
 * @param paramOptions
 * @returns {string}
 */
function append() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var paramOptions = arguments[1];

    if (!url || !paramOptions || !isCDNUrl(url)) {
        return url;
    }

    // 1. 处理传入object参数，合并
    var newQueryParam = isObject(paramOptions) ? paramOptions : parse(paramOptions);
    var isSupportWebP = IS_BROWSER_ENV && __WEBPACK_IMPORTED_MODULE_0_zzc_webp_check___default()();

    if (url.indexOf(START_PARAM) > -1) {
        // 2. 处理地址上的，转化为object
        var urlQueryParam = parse(url);

        for (var name in newQueryParam) {
            if (hasOwnProperty(newQueryParam, name)) {
                if (IS_BROWSER_ENV && name === 'format' && newQueryParam[name] === 'webp' && !isSupportWebP) {
                    continue;
                }
                urlQueryParam[name] = newQueryParam[name];
            }
        }

        // 3. 移除url上，补上合并的
        return clean(url) + stringify(urlQueryParam);
    } else {
        if (newQueryParam.format && IS_BROWSER_ENV && !isSupportWebP) {
            delete newQueryParam.format;
        }
        return url + stringify(newQueryParam);
    }
}

/**
 * 清除参数
 *
 * @param url
 * @returns {string}
 */
function clean() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return url ? url.replace(RE_EXT_QUERY, '$1') : url;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["WebPCheck"] = factory();
	else
		root["WebPCheck"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = WebPCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webpcheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webpcheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_webpcheck__);


function include(str, findStr) {
    return str.indexOf(findStr) !== -1;
}
function isNull(s) {
    return {}.toString.call(s) === '[object Null]';
}
function toInt(s) {
    return parseInt(s, 10) || 0;
}

var RE_ZZC_IOS_VERSION = /zzcios\/([\d\.]+)(?:\/vip|)\s\(/;

function checkZZCAppSupportIniOS() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    userAgent = (userAgent || window.navigator.userAgent).toLowerCase();

    if (include(userAgent, 'zzcios/com.tantu.travel/')) {
        // 探途旅行app
        return true;
    } else if (RE_ZZC_IOS_VERSION.test(userAgent)) {
        // 租租车app
        // 版本判断
        var VersionMatch = userAgent.match(RE_ZZC_IOS_VERSION);
        VersionMatch = VersionMatch && VersionMatch.length > 1 ? VersionMatch[1] : -1;
        if (VersionMatch !== -1) {
            VersionMatch = VersionMatch.split('.');
            return toInt(VersionMatch[0]) >= 5 && toInt(VersionMatch[1]) >= 2 && toInt(VersionMatch[2]) >= 25;
        }
    }

    return false;
}

var isZZCAppSupportIniOS = checkZZCAppSupportIniOS();

var isSupportWebPResult = null;
function WebPCheck() {
    if (isNull(isSupportWebPResult)) {
        if (isZZCAppSupportIniOS) {
            isSupportWebPResult = true;
        } else {
            var checkState = __WEBPACK_IMPORTED_MODULE_0_webpcheck___default.a.state();
            if (checkState === 'done') {
                isSupportWebPResult = __WEBPACK_IMPORTED_MODULE_0_webpcheck___default()();
            } else if (checkState === null) {
                __WEBPACK_IMPORTED_MODULE_0_webpcheck___default()();
            }
        }
    }

    return !!isSupportWebPResult;
}

WebPCheck.result = function () {
    return isZZCAppSupportIniOS ? {
        lossy: true, lossless: true, alpha: true, animation: true
    } : __WEBPACK_IMPORTED_MODULE_0_webpcheck___default.a.result();
};
WebPCheck.clean = function () {
    isSupportWebPResult = null;
    return __WEBPACK_IMPORTED_MODULE_0_webpcheck___default.a.clean();
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["WebPCheck"] = factory();
	else
		root["WebPCheck"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(1);

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = WebPCheck;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEST_IMAGES_BASE64 = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
};

var localStorageSupported = function () {
    try {
        var str = 'test' + new Date().getTime();
        localStorage.setItem(str, str);
        localStorage.removeItem(str);
        return true;
    } catch (e) {
        return false;
    }
}();

// ========== 常用函数
function isType(s, typeString) {
    return {}.toString.call(s) === '[object ' + typeString + ']';
}
function isObject(s) {
    return isType(s, 'Object');
}
function isNull(s) {
    return isType(s, 'Null');
}
function storageSetItem(val) {
    localStorageSupported && localStorage.setItem(STORAGE_KEY, val);
}
function storageGetItem() {
    return localStorageSupported ? localStorage.getItem(STORAGE_KEY) : false;
}
function storageRemoveItem() {
    return localStorageSupported ? localStorage.removeItem(STORAGE_KEY) : false;
}

function load(caseItemName, cb) {
    if (!TEST_IMAGES_BASE64[caseItemName]) {
        return;
    }

    var img = new Image();
    img.onload = function () {
        cb(caseItemName, img.width > 0 && img.height > 0);
        img.onload = img.onerror = null;
        img = null;
    };
    img.onerror = function () {
        cb(caseItemName, false);
        img.onload = img.onerror = null;
        img = null;
    };
    img.src = 'data:image/webp;base64,' + TEST_IMAGES_BASE64[caseItemName];
}

// ========== 配置
var STORAGE_KEY = '_webPCheckResult';

// ========== 检查流程
var WebPCheckResultDetail = null;
var WebPCheckResult = null;
var WebPCheckState = null;

function WebPCheck() {
    if (isNull(WebPCheckResult)) {
        var storageResult = WebPCheck.result();
        if (isObject(storageResult)) {
            WebPCheckState = 'done';
            WebPCheckResult = storageResult.lossy || storageResult.lossless || storageResult.alpha || storageResult.animation;
        } else if (isNull(WebPCheckState) && isNull(WebPCheckResultDetail)) {
            (function () {
                WebPCheckResultDetail = {};
                WebPCheckState = 'checking';

                var testCases = ['lossy', 'lossless', 'alpha', 'animation'];
                var caseItemName = void 0;
                var totalCheck = testCases.length;
                var currentCheck = 0;
                while (caseItemName = testCases.shift()) {
                    load(caseItemName, function (name, response) {
                        ++currentCheck;

                        WebPCheckResultDetail[name] = response;

                        if (totalCheck === currentCheck) {
                            storageSetItem((0, _stringify2.default)(WebPCheckResultDetail));
                            WebPCheckState = 'done';
                        }
                    });
                }
            })();
        }
    }

    return !!WebPCheckResult;
}

WebPCheck.clean = function () {
    WebPCheckResultDetail = null;
    WebPCheckResult = null;
    WebPCheckState = null;
    storageRemoveItem();
};

WebPCheck.result = function () {
    if (localStorageSupported) {
        return JSON.parse(storageGetItem());
    } else if (localStorageSupported === false && isObject(WebPCheckResultDetail)) {
        return WebPCheckResultDetail;
    } else {
        return false;
    }
};

WebPCheck.state = function () {
    return WebPCheckState;
};
WebPCheck();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2), __esModule: true };

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(3);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ })
/******/ ])["default"];
});

/***/ })
/******/ ])["default"];
});

/***/ })
/******/ ]);
});